import { render, staticRenderFns } from "./Licentie.vue?vue&type=template&id=cf7841e4&scoped=true"
import script from "./Licentie.vue?vue&type=script&lang=js"
export * from "./Licentie.vue?vue&type=script&lang=js"
import style0 from "./Licentie.vue?vue&type=style&index=0&id=cf7841e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7841e4",
  null
  
)

export default component.exports